var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-skip-nav"},[_c('a',{attrs:{"href":((_vm.$route.path) + "#mainContent")}},[_vm._v("Skip to main content")])])}
var staticRenderFns = []

export { render, staticRenderFns }